import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefConfigurationStatusQuery, KsefConfigurationStatusQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefConfigurationStatusQuery)
@Wrapper(KsefConfigurationStatusQueryHandlerBase)
export class KsefConfigurationStatusQueryHandler {
    public constructor(
        http: Http
    ) { }
}
